document.addEventListener('DOMContentLoaded', () => {
  const wrap = document.querySelector('[data-predictive-search]');
  if (!wrap) return;
  const input = wrap.querySelector('input[type="search"]');
  const results = wrap.querySelector('[data-search-results]');
  const limit = parseInt(wrap.getAttribute('data-limit') || '6', 10);
  const showVendor = wrap.getAttribute('data-show-vendor') === 'true';
  const showPrice = wrap.getAttribute('data-show-price') !== 'false';
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  let timer = null;

  function hide() { results.hidden = true; results.innerHTML = ''; }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 3) { hide(); return; }
    timer = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + limit + '&resources[options][unavailable_products]=hide')
        .then((r) => r.json())
        .then((data) => {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { hide(); return; }
          results.innerHTML =
            products.map((p) =>
              '<a class="ps-item" href="' + p.url + '">' +
              (p.featured_image ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span class="ps-noimg"></span>') +
              '<span class="ps-info"><b>' + p.title + '</b>' +
              (showVendor && p.vendor ? '<small>' + p.vendor + '</small>' : '') +
              (showPrice ? '<span class="price">' + money(p.price) + '</span>' : '') +
              '</span></a>'
            ).join('') +
            '<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>';
          results.hidden = false;
        })
        .catch(() => hide());
    }, 250);
  });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });
  input.addEventListener('blur', () => setTimeout(hide, 200));
  input.addEventListener('focus', () => { if (results.innerHTML) results.hidden = false; });
});
